export enum BaccaratPhase {
    WaitingForCroupier = 'WaitingForCroupier',
    WaitingForPlayers = 'WaitingForPlayers',
    NewRoundPreparation = 'NewRoundPreparation',
    BetsOpen = 'BetsOpen',
    BetsClosed = 'BetsClosed',
    DealingCards = 'DealingCards',
    RoundEnd = 'RoundEnd',
    ShoeChange = 'ShoeChange',
    CardBurn = 'CardBurn',
    RoundVoid = 'RoundVoid',
    RoundError = 'RoundError'
}

export enum CardPosition {
    PlayerFirstCard = 'PlayerFirstCard',
    BankerFirstCard = 'BankerFirstCard',
    PlayerSecondCard = 'PlayerSecondCard',
    BankerSecondCard = 'BankerSecondCard',
    PlayerThirdCard = 'PlayerThirdCard',
    BankerThirdCard = 'BankerThirdCard'
}

export enum BaccaratOutcome {
    BankerWin = 'BankerWin',
    PlayerWin = 'PlayerWin',
    Tie = 'Tie'
}

export enum DealerConsoleAction {
    ChangeShoe = 'ChangeShoe',
    ShoeChanged = 'ShoeChanged'
}

export enum FlagStateType {
    ChatEnabled = 'ChatEnabled',
    RoundFlagged = 'RoundFlagged',
    RoundBetsFree = 'RoundBetsFree',
    TableClosingRequested = 'TableClosingRequested',
    SupervisorCalled = 'SupervisorCalled'
}

export enum DealerAssistTableErrorCode {
    AuthenticationFailed = 'AuthenticationFailed',
    BackendDisconnected = 'BackendDisconnected',
    CroupierChangeInvalidState = 'CroupierChangeInvalidState',
    DuplicateCard = 'DuplicateCard',
    FlagFailed = 'FlagFailed',
    InvalidCard = 'InvalidCard',
    InvalidCroupierId = 'InvalidCroupierId',
    RoundOpeningFailed = 'RoundOpeningFailed',
    RoundResultSavingFailed = 'RoundResultSavingFailed',
    ScannerDisconnected = 'ScannerDisconnected'
}
